import { clientBase } from "../common";

export const getItems = (_perPage, _currentPage) => {
  return clientBase(`v2/userCoursesFilter?paginate=${_perPage}&page=${_currentPage}&proyect=${process.env.VUE_APP_PROYECT_ID}`, "GET");
};

export const postUserResourse = (_body) => {
  return clientBase(`v2/addUserResource`, "POST", {
    body: _body,
  });
};

